import { dataConstants } from '_constants';

const setVal = (name, val)  => ({ 
    type: dataConstants.SET_VAL, 
    name, 
    val
});

export const dataActions = {
    setVal
};